import React from 'react';
import axios from 'axios';
import { Button, Form, Input } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class NewExamGroup extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            staff: [],
            name: '',
            staffIds: [],

            nameErr: false,
            groupTypeErr: false,
            staffIdsErr: false,
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.createGroup = this.createGroup.bind(this);
    }

    componentDidMount() {
        axios.get(`course/implementation/staff/${localStorage.getItem('courseImplementationId')}`)
            .then(res => {
                const staff = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.employee.person.firstName + ' ' + el.employee.person.lastName + ' (' + el.courseRoleType.name + ')'
                }));
                this.setState({ staff });
            })
            .catch(err => {
                console.log('Failed to fetch staff');
            });

        axios.get('/group-types')
            .then(res => {
                let groupType = res.data.find(e => e._key === 'exam').id;
                localStorage.setItem('groupType', groupType);
            })
            .catch(err => {
                console.log('Failed to fetch group types');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    createGroup() {
        const { name, staffIds } = this.state;

        if (!name || staffIds.length === 0) {
            toast('Niste unijeli sva obavezna polja!');
            if (!name) { this.setState({ nameErr: true }); } else { this.setState({ nameErr: false }); }
            if (staffIds.length === 0) { this.setState({ staffIdsErr: true }); } else { this.setState({ staffIdsErr: false }); }
        }
        let groupTypes = [{ id: localStorage.getItem('groupType') }];

        const newGroup = {
            name,
            courseImplementation: { id: localStorage.getItem('courseImplementation') ? localStorage.getItem('courseImplementation') : localStorage.getItem('courseImplementationId') },
            groupTypes
        };

        axios.post('course/groups/add', { ...newGroup })
            .then(res => {
                let staffGroup = staffIds.map(el => ({
                    courseImplementationStaff: { id: el },
                    courseImplementationGroup: { id: res.data.id }
                }));

                let group = [res.data.id];

                axios.post('course/groups/add-staff', [...staffGroup])
                    .then(ress => {
                        axios.post(`exams/add-group/${localStorage.getItem('gradedActivityId')}`, [...group])
                            .then(re => {
                                toast('Uspješno ste kreirali ispitnu grupu i dodali je na ispit.');
                                this.props.close();
                                this.props.getGroups();
                            });
                    });
            })
            .catch(err => {
                toast('Došlo je do greške! Ispitna grupa nije kreirana.');
                this.props.close();
            });
    }


    render() {
        return (
            <div>
                <Form noValidate>
                    <Form.Field
                        required
                        control={Input}
                        label="Naziv studentske grupe"
                        value={this.state.name}
                        onChange={(e) => this.setState({ name: e.target.value })}
                        name="name"
                        placeholder="Unesite naziv studentske grupe"
                        error={this.state.nameErr}
                    />

                    <Form.Field required error={this.state.staffIdsErr}>
                        <Form.Dropdown
                            clearable
                            placeholder="Odaberite nastavno osoblje"
                            value={this.state.staffIds}
                            onChange={this.handleInputChange}
                            name="staffIds"
                            options={this.state.staff}
                            label="Nastavno osoblje"
                            search
                            fluid
                            selection
                            multiple
                        />
                    </Form.Field>
                    <br />
                    <Button color="blue" onClick={this.createGroup}>Kreiraj grupu</Button>
                    <Button color="blue" basic="true" onClick={this.props.close}>Odustani</Button>
                </Form>
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamTerms/NewExamGroup.js